import React, { useEffect, useState } from 'react'

import { User } from 'core/application/account/loginUser'
import { Permissions } from 'core/application/account/permissions'
import { EmployeeSignupState } from 'core/application/employeeSignup/employeeSignupState'
import updatePerksPersonalDetails from 'core/application/employeeSignup/perks/updatePersonalDetails'
import employeeSignupState from 'core/application/nonEligibleEmployeeSignup/nonEligibleEmployeeSignupState'
import employeeSignupWizard from 'core/application/nonEligibleEmployeeSignup/nonEligibleEmployeeSignupWizard'

import useLoginUser from 'common/hooks/useLoginUser'

import EmployeeSignup from '../../common/EmployeeSignup'
import { NavItemProps } from '../../common/models'
import PersonalDetails, { PersonalDetailsProps } from '../../common/personalDetails'

export const NON_ELIGIBLE_EMPLOYEE_SIGNUP_FLOW_PATH = '/non-ee-signup-flow'

interface NonEligibleEmployeeSignupProps {}

const PerksNonEligibleEmployeeSignup: React.FC<NonEligibleEmployeeSignupProps> = () => {
  const [user] = useLoginUser()

  const userIsAllowedToEnterEmployeeSignUpFlow = (user: User): boolean => {
    return user !== null && user.permissions.includes(Permissions.AccessNonEligibleEmployeeSignupWizard)
  }

  return (
    <EmployeeSignup
      signupFlowPath={NON_ELIGIBLE_EMPLOYEE_SIGNUP_FLOW_PATH}
      isUserAllowedToEnterSignupFlow={userIsAllowedToEnterEmployeeSignUpFlow(user)}
      employeeSignupWizard={employeeSignupWizard}
      employeeSignupStateApi={employeeSignupState}
      navItemsMapping={NonEEPerksNavItemsMapping}
    />
  )
}

enum NonEligibleEmployeeSignupStep {
  PersonalDetails = 'perks-non-ee-personal-details',
}

const NonEEPerksNavItemsMapping: NavItemProps[] = [
  {
    key: NonEligibleEmployeeSignupStep.PersonalDetails,
    component: PersonalDetails,
    nextButtonTooltip: 'Lorem ipsum',
    mapState: (employeeSignupState: EmployeeSignupState | undefined): PersonalDetailsProps => {
      return {
        personalDetailValues: {
          personalEmail: employeeSignupState ? employeeSignupState.personalEmail : null,
          phoneNumber: employeeSignupState ? employeeSignupState.phoneNumber : null,
        },
        submitHandler: (values: any) => updatePerksPersonalDetails(values),
        numberOfQuestions: 1,
        currentQuestion: 1,
        next: false,
      }
    },
    icon: 'user',
  },
]

export default PerksNonEligibleEmployeeSignup
